module.exports = __webpack_public_path__ + "img/step5-05.950e4fb2.jpg";